import {
  LandingCard,
  PortalCapabilitiesItem,
  SidebarItemLink,
} from './LandingPage.types';

export const LOGIN_ACTION = 'login';
export const CONTACT_US_ROUTE = '/contact-us';
export const RELEASE_NOTES_ROUTE = '/docs-v2/release-notes';
export const GETTING_STARTED_ROUTE = '/docs-v2/getting-started';

export const sidebarLinks: SidebarItemLink[] = [
  { label: 'Home', to: LOGIN_ACTION, redirectTo: '/' },
  { label: 'APIs', to: LOGIN_ACTION, redirectTo: '/api-docs' },
  { label: 'Docs', to: LOGIN_ACTION, redirectTo: '/docs-v2' },
  { label: 'Support', to: CONTACT_US_ROUTE },
];

export function getLandingCards(): LandingCard[] {
  return [
    {
      title: 'Discover Our APIs',
      description:
        'Explore the full range of Digital Realty APIs. Browse documentation, start testing, and see how our APIs can power your next solution.',
      to: LOGIN_ACTION,
      redirectTo: '/api-docs',
      image: '/landing/laptop.png',
      showForUnregisteredUsers: true,
    },
    {
      title: 'Getting Started Guide',
      description:
        'Access all developer tools in one place through the Digital Realty Developer Portal.',
      to: LOGIN_ACTION,
      redirectTo: GETTING_STARTED_ROUTE,
      image: '/landing/books.jpg',
      showForUnregisteredUsers: true,
    },
    {
      title: 'Need Support?',
      description:
        'Have questions about using our APIs or moving to production? Visit our support form and reach out to our team for help.',
      to: CONTACT_US_ROUTE,
      image: '/landing/callCenter.jpg',
      showForUnregisteredUsers: true,
    },
    {
      title: 'Release Notes',
      description:
        'Stay up to date with the latest API updates, improvements, and bug fixes. Review recent releases to see what’s new and what’s changed.',
      to: RELEASE_NOTES_ROUTE,
      image: '/landing/releaseNotes.jpg',
      showForUnregisteredUsers: false,
    },
  ];
}

export const portalCapabilities: PortalCapabilitiesItem[] = [
  {
    label: 'Register Applications',
    icon: '/landing/icons/register_applications.svg',
  },
  {
    label: 'Subscribe to API Products',
    icon: '/landing/icons/subscribe_products.svg',
  },
  {
    label: 'Playground Access',
    icon: '/landing/icons/register_applications.svg',
  },
  { label: 'Sandbox Access', icon: '/landing/icons/sandbox.svg' },
  { label: 'Production Access', icon: '/landing/icons/production_access.svg' },
  { label: 'API Discovery', icon: '/landing/icons/api_discovery.svg' },
  { label: 'Analytics', icon: '/landing/icons/analytics.svg' },
  { label: 'Data Storage', icon: '/landing/icons/data_storage.svg' },
  {
    label: 'Comprehensive Documentation',
    icon: '/landing/icons/comphensive_doc.svg',
  },
  { label: 'Monitoring', icon: '/landing/icons/monitoring.svg' },
];
